import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  PROPERTY_ATTRIBUTE_CATEGORY_LISTING_FIELD,
} from 'common/propertyAttributeConstants';

import SrBox from 'client/components/SrBox';
import SrIcon from 'client/components/SrIcon';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrPropertyAttributeListingFieldListForm from 'client/components/SrPropertyAttributeListingFieldListForm';

class SrPropertyAttributeListingFieldFormModal extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    formType: PropTypes.string.isRequired,
    propertyAttributes: PropTypes.array.isRequired,
    apartmentId: PropTypes.number.isRequired,
    apartmentBuildingId: PropTypes.number,
    floorPlanId: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  static defaultProps = {
    apartmentBuildingId: null,
    floorPlanId: null,
  }

  render() {
    const {
      title,
      formType,
      propertyAttributes,
      apartmentId,
      floorPlanId,
      apartmentBuildingId,
      onChange,
      onClose,
      dispatch,
    } = this.props;

    return (
      <SrDarkModal className='SrPropertyAttributeListingFieldFormModal'>
        <SrBox top={2} left={2} position='fixed' onClick={onClose}>
          <SrIcon className='x-close-large-white' />
        </SrBox>
        <SrModalContent>
          <SrPropertyAttributeListingFieldListForm
            title={title}
            formType={formType}
            propertyAttributes={propertyAttributes.filter((propertyAttribute) => (
              propertyAttribute.apartmentId === apartmentId
              && propertyAttribute.apartmentBuildingId === apartmentBuildingId
              && propertyAttribute.floorPlanId === floorPlanId
              && propertyAttribute.category === PROPERTY_ATTRIBUTE_CATEGORY_LISTING_FIELD
            ))}
            apartmentId={apartmentId}
            apartmentBuildingId={apartmentBuildingId}
            floorPlanId={floorPlanId}
            dispatch={dispatch}
            onChange={onChange}
            onClose={onClose}
          />
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrPropertyAttributeListingFieldFormModal.displayName = 'SrPropertyAttributeListingFieldFormModal';

export default SrPropertyAttributeListingFieldFormModal;
